import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

/**
 * Unauthenticated API client for Whop OAuth bootstrap.
 * Must not attach Firebase tokens or Whop secrets.
 */
const publicClient = () =>
  axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 20000,
  });

export default {
  async startWhopLogin() {
    const res = await publicClient().get("/auth/whop/start");
    return res.data;
  },

  async completeWhopLogin(code, state) {
    const res = await publicClient().post("/auth/whop/callback", {
      code,
      state,
    });
    return res.data;
  },
};
